import { ColAntd, Container, Header, RowAntd, SubHeader } from './styles'
import SelectClaimTreatmentType from './SelectClaimTreatmentType/SelectClaimTreatmentType'
import SupportingDocumentsForClaim from './SupportingDocumentsForClaim/SupportingDocumentsForClaim'
import HealthClaimDetailPageHook from './HealthClaimDetailPage.hook'
import ClaimDetailTitle from './ClaimDetailTitle/ClaimDetailTitle'
import ClaimActionBar from './ClaimActionBar/ClaimActionBar'
import InsuredPersonDetail from './InsuredPersonDetail/InsuredPersonDetail'
import CompensationRequestPanel from './CompensationRequestPanel'
import TreatmentDetailPanel from '@/components/feature/HealthClaimDetailPage/TreatmentDetailPanel'
import { createContext, PropsWithChildren, useReducer } from 'react'
import { DocumentAction, DocumentItem } from './SupportingDocumentsForClaimTabDocument/types'
import { HealthClaimFormProvider } from '@/contexts/healthClaimForm'
import ClaimInfoSubtitle from './ClaimInfoSubtitle/ClaimInfoSubtitle'
import { useSupportingDocumentsForClaim } from '@/hooks'

export const DocumentDispatchContext = createContext<React.Dispatch<DocumentAction>>(
  () => undefined,
)

export const DocumentContext = createContext<DocumentItem[]>([])

export const DocumentProvider = ({ children }: PropsWithChildren) => {
  const { documentReducer, initialState } = useSupportingDocumentsForClaim()

  const [documents, dispatch] = useReducer(documentReducer, initialState)

  return (
    <DocumentContext.Provider value={documents}>
      <DocumentDispatchContext.Provider value={dispatch}>
        {children}
      </DocumentDispatchContext.Provider>
    </DocumentContext.Provider>
  )
}

const HealthClaimDetailPage = () => {
  return (
    <DocumentProvider>
      <HealthClaimDetailPageInner />
    </DocumentProvider>
  )
}

const HealthClaimDetailPageInner = () => {
  const { mockHook } = HealthClaimDetailPageHook()

  return (
    <HealthClaimFormProvider>
      <Container>
        <Header>
          <SubHeader>
            <ClaimDetailTitle />
            <ClaimActionBar />
          </SubHeader>
          <ClaimInfoSubtitle />
        </Header>
        <RowAntd gutter={[16, 24]}>
          <ColAntd span={24}>
            <InsuredPersonDetail />
          </ColAntd>
          <ColAntd span={24}>
            <SelectClaimTreatmentType />
          </ColAntd>
          <ColAntd span={24}>
            <TreatmentDetailPanel />
          </ColAntd>
          <ColAntd span={24}>
            <CompensationRequestPanel />
          </ColAntd>
          <ColAntd span={24}>
            <SupportingDocumentsForClaim />
          </ColAntd>
        </RowAntd>
      </Container>
    </HealthClaimFormProvider>
  )
}

export default HealthClaimDetailPage
